import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';

export function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <div className="content-wrapper--medium">
        <div className="mb-4 flex items-center justify-between">
          <Link to="/" className="btn-text inline-block">
            ← {t('privacy.backHome')}
          </Link>
          <LanguageSwitcher />
        </div>

        <h1 className="page-title">{t('privacy.title')}</h1>

        <div className="card space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('privacy.dataCollectionTitle')}
            </h2>
            <p className="text-gray-700">{t('privacy.dataCollectionDesc')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('privacy.deepAnalysisTitle')}
            </h2>
            <p className="text-gray-700">{t('privacy.deepAnalysisDesc')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('privacy.smsTitle')}
            </h2>
            <p className="text-gray-700">{t('privacy.smsDesc')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('privacy.feedbackTitle')}
            </h2>
            <p className="text-gray-700">{t('privacy.feedbackDesc')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {t('privacy.trackingTitle')}
            </h2>
            <p className="text-gray-700">{t('privacy.trackingDesc')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
